import {createWebHistory, createRouter} from "vue-router";


import auth from './auth';
import app from './app';
import edit from './edit';
import checkout from './payment';
import admin from './admin';
const routes = auth.concat(app,edit,checkout,admin)
window.router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
